import { fetchAdvSeoDetails, getFeatureLocks } from '../services';

export async function fetchAdditionalPageSeoDetails(propData) {
  const featureLocks = await getFeatureLocks(propData?.storeInfo?.store_id);
  const isSeoFeatureUnlocked = !featureLocks?.['seo']?.is_locked;
  if (!!isSeoFeatureUnlocked) {
    const advSeoResponse = await fetchAdvSeoDetails({
      type: propData?.type,
      typeId: propData?.typeId,
      storeId: propData?.storeInfo?.store_id,
    });

    if (advSeoResponse.data && advSeoResponse.data.status) {
      return JSON.parse(advSeoResponse.data.data);
    }
  }
  return {};
}
